import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {RequesterService} from '../../services/requester.service';
import {SimulatorResultModel} from './models/simulator-result.model';
import {EventsService} from '../../services/events.service';
import {Subscription} from 'rxjs';
import {NavService} from '../../services/nav.service';

@Injectable({
    providedIn: 'root'
})
export class SimulatorService {

    public result: SimulatorResultModel = null;
    subscriptions: Subscription[] = [];

    constructor(
        private router: Router,
        private requesterService: RequesterService,
        private event: EventsService
    ) {
        this.subscriptions.push(
            this.event.subscribe('login', () => {
                this.result = null;
            })
        );
    }

    getMySimulatorResult(): Promise<SimulatorResultModel> {
        if (this.result !== null) {
            return Promise.resolve(this.result)
        } else {
            return this.requesterService.get('getMySimulatorResult', {})
                .then(data => {
                    if (!!data.result) {
                        this.result = data.result;
                        return data.result;
                    }
                    return null;
                })
                .catch(e => {
                    console.log('Error getMySimulatorResult >> ', e);
                });
        }
    }

    saveMySimulatorResult(type, questions, result, score, started_at): Promise<SimulatorResultModel> {
        return this.requesterService.post('saveMySimulatorResult', {
            type, questions, result, score,
            started_at: started_at.toISOString(),
            completed_at: (new Date).toISOString()
        })
            .then(data => {
                if (!!data.result) {
                    this.result = data.result;
                    this.event.publish('simulator.saveMySimulatorResult', this.result);
                    return data.result;
                }
                return null;
            })
            .catch(e => {
                console.log('Error saveMySimulatorResult >> ', e);
            });
    }

    saveMySimulatorProgress(type, question): Promise<SimulatorResultModel> {
        return this.requesterService.post('saveMySimulatorProgress', {
            type, question
        })
            .then(data => {
                if (!!data.result) {
                    return data.result;
                }
                return null;
            })
            .catch(e => {
                console.log('Error saveMySimulatorProgress >> ', e);
            });
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(i => i.unsubscribe());
    }
}
